import {
  Alert,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  Box,
  Autocomplete,
} from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import {
  fetchLocalidadesPorProvincia,
  deleteTelefono,
  fetchUsuarios,
} from "../../services/empleados.api";
import { useLegajosContext } from "../../../../context/LegajoTabsContext";
import GoogleMapPicker from "../../../../components/GoogleMapPicker";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import { Checkbox, Divider, FormControlLabel, Typography } from "@mui/material";
import moment from "moment";
export default function PersonalForm({ isEditing, cuil }) {
  const {
    formData,
    updateFormData,
    errors,
    referenceData,
    handlePersonalDataChange,
    addPhone,
    updatePhone,
    removePhone,
  } = useLegajosContext();
  const { tiposDoc, provincias, estadosCiviles, paises, telefonosTipos } =
    referenceData;

  const [localidades, setLocalidades] = useState([]);
  const [localitiesLoading, setLocalitiesLoading] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [usuariosLoading, setUsuariosLoading] = useState(false);

  const datos = formData?.datosPersonales || {};
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    index: null,
    phone: null,
  });

  useEffect(() => {
    const cargarUsuarios = async () => {
      setUsuariosLoading(true);
      try {
        const data = await fetchUsuarios();
        if (Array.isArray(data)) {
          setUsuarios(data);
        }
      } catch (err) {
        console.error("Error al cargar usuarios:", err);
      } finally {
        setUsuariosLoading(false);
      }
    };
    cargarUsuarios();
  }, []);

  useEffect(() => {
    if (datos?.id_provincia) {
      const cargarLocalidades = async () => {
        setLocalitiesLoading(true);
        try {
          const data = await fetchLocalidadesPorProvincia(datos.id_provincia);
          setLocalidades(data);
        } catch (err) {
          console.error("Error al cargar localidades:", err);
        } finally {
          setLocalitiesLoading(false);
        }
      };
      cargarLocalidades();
    } else {
      setLocalidades([]);
      setLocalitiesLoading(false);
    }
  }, [datos?.id_provincia]);

  const OPCIONES_SEXO = [
    { value: "Femenino", label: "Femenino" },
    { value: "Masculino", label: "Masculino" },
    { value: "No Binario", label: "No Binario" },
  ];

  const handleDeleteClick = (index, phone) => {
    setDeleteDialog({ open: true, index, phone });
  };

  const handleConfirmDeletePhone = async () => {
    if (deleteDialog.index !== null) {
      const { phone, index } = deleteDialog;
      const cuilEmpleadoEdit = cuil;

      if (cuilEmpleadoEdit && phone?.id) {
        try {
          await deleteTelefono(cuilEmpleadoEdit, phone.id);
        } catch (error) {
          console.error("Error al eliminar teléfono de la API:", error);
        }
      }
      removePhone(index);
    }
    setDeleteDialog({ open: false, index: null, phone: null });
  };
  console.log("username", datos.username);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4} sm={4} lg={2}>
          <TextField
            fullWidth
            label="CUIL"
            name="cuil"
            inputProps={{ readOnly: isEditing }}
            value={datos.cuil || ""}
            type="text"
            onChange={handlePersonalDataChange}
            error={!!errors?.cuil}
            helperText={errors?.cuil}
            onKeyDown={(e) => {
              if (["-", "e", "E", "+"].includes(e.key)) {
                e.preventDefault();
              }
            }}
            placeholder="20123456789"
            required
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} md={4} sm={4} lg={2}>
          <TextField
            fullWidth
            label="Número de Legajo"
            name="nro_legajo"
            value={datos.nro_legajo || ""}
            onChange={handlePersonalDataChange}
            error={!!errors?.nro_legajo}
            helperText={errors?.nro_legajo}
            inputProps={{ readOnly: isEditing }}
            placeholder="12345"
            required
            variant="standard"
          />
        </Grid>
        <Grid item sm={6} xs={8} md={4} lg={2}>
          <FormControl
            fullWidth
            disabled={isEditing}
            variant="standard"
            focused
            InputLabelProps={{ shrink: true }}
            // Esto es crucial para la validación: marca el campo si tiene error
            error={!!errors?.id_tipo_doc}
          >
            <InputLabel>Tipo de Documento</InputLabel>
            <Select
              name={"id_tipo_doc"}
              value={datos.id_tipo_doc || ""}
              inputProps={{ shrink: true }}
              label="Tipo de Documento"
              onChange={handlePersonalDataChange}
              focused
            >
              {/* Opción deshabilitada para "placeholder" si es necesario */}
              <MenuItem value="" disabled>
                Selecciona un Tipo de Documento
              </MenuItem>

              {/* Mapea tus opciones */}
              {tiposDoc.map((opcion, index) => (
                <MenuItem key={`${opcion.id}-${index}`} value={opcion.id}>
                  {opcion.tipo}
                </MenuItem>
              ))}
            </Select>

            {/* Muestra el mensaje de error debajo del campo */}
            {errors?.id_tipo_doc && (
              <FormHelperText>{errors?.id_tipo_doc}</FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <TextField
            fullWidth
            label="Número de Documento"
            inputProps={{ readOnly: isEditing }}
            name="nro_doc"
            variant="standard"
            value={datos.nro_doc || ""}
            onChange={handlePersonalDataChange}
            error={!!errors?.nro_doc}
            helperText={errors?.nro_doc}
            placeholder="12345678"
            required
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <TextField
            fullWidth
            variant="standard"
            inputProps={{ readOnly: isEditing }}
            label="Nombre"
            name="nombre"
            value={datos.nombre || ""}
            onChange={handlePersonalDataChange}
            error={!!errors?.nombre}
            helperText={errors?.nombre}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <TextField
            fullWidth
            label="Apellido"
            name="apellido"
            variant="standard"
            inputProps={{ readOnly: isEditing }}
            value={datos.apellido || ""}
            onChange={handlePersonalDataChange}
            error={!!errors?.apellido}
            helperText={errors?.apellido}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <TextField
            fullWidth
            label="Fecha de Nacimiento"
            name="fecha_nacimiento"
            variant="standard"
            type="date"
            value={
              datos.fecha_nacimiento
                ? moment(datos.fecha_nacimiento).format("YYYY-MM-DD")
                : ""
            }
            onChange={handlePersonalDataChange}
            error={!!errors?.fecha_nacimiento}
            helperText={errors?.fecha_nacimiento}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              max: moment().format("YYYY-MM-DD") || null,
              readOnly: isEditing,
            }}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          {/* 2. SELECT: ESTADO CIVIL */}
          <FormControl
            fullWidth
            variant="standard"
            required
            inputProps={{ readOnly: isEditing }}
            InputLabelProps={{ shrink: true }}
          >
            <InputLabel id="estado-civil-label">Estado Civil</InputLabel>
            <Select
              labelId="estado-civil-label"
              id="id_estado_civil"
              name="id_estado_civil"
              value={datos.id_estado_civil || ""}
              label="Estado Civil"
              disabled={isEditing}
              onChange={handlePersonalDataChange}
            >
              {estadosCiviles.map((estado, index) => (
                <MenuItem key={`${estado.id}-${index}`} value={estado.id}>
                  {estado.descripcion}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <FormControl
            fullWidth
            variant="standard"
            required
            disabled={isEditing}
            InputLabelProps={{ shrink: true }}
          >
            <InputLabel id="sexo-label">Sexo</InputLabel>
            <Select
              labelId="sexo-label"
              id="sexo"
              inputProps={{ shrink: true }}
              name="sexo" // El campo en formData.datosPersonales se llama 'sexo'
              value={datos.sexo || ""} // El valor será un string o ""
              label="Sexo"
              onChange={handlePersonalDataChange}
            >
              {OPCIONES_SEXO.map((opcion) => (
                <MenuItem key={opcion.value} value={opcion.value}>
                  {opcion.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          {/* 3. AUTOCOMPLETE: PROVINCIA */}
          <Autocomplete
            disabled={isEditing}
            options={provincias}
            getOptionLabel={(option) => option.provincia || ""}
            value={
              provincias?.find((p) => p.id === datos?.id_provincia) || null
            }
            onChange={(event, newValue) => {
              // Al cambiar de provincia, reseteamos la localidad
              handlePersonalDataChange({
                target: {
                  name: "id_provincia",
                  value: newValue ? newValue.id : "",
                },
              });
              handlePersonalDataChange({
                target: { name: "id_localidad", value: "" },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Provincia"
                variant="standard"
                required
                InputLabelProps={{ shrink: true }}
                error={!!errors?.id_provincia}
                helperText={errors?.id_provincia}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          {/* 4. AUTOCOMPLETE: LOCALIDAD (Dependiente) */}
          <Autocomplete
            disabled={!datos.id_provincia || localitiesLoading || isEditing}
            options={localidades}
            getOptionKey={(localidad) => localidad.id}
            getOptionLabel={(localidad) => localidad.localidad || ""}
            value={
              localidades?.find((l) => l.id === datos?.id_localidad) || null
            }
            noOptionsText={
              !datos.id_provincia
                ? "Primero seleccione una Provincia"
                : "Sin localidades"
            }
            onChange={(event, newValue) => {
              handlePersonalDataChange({
                target: {
                  name: "id_localidad",
                  value: newValue ? newValue.id : "",
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Localidad"
                variant="standard"
                required
                InputLabelProps={{ shrink: true }}
                error={!!errors?.id_localidad}
                helperText={errors?.id_localidad}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <TextField
            fullWidth
            variant="standard"
            label="Patente Automóvil"
            name="patente_automovil"
            error={!!errors?.patente_automovil}
            helperText={errors?.patente_automovil}
            value={datos.patente_automovil || ""}
            inputProps={{ readOnly: isEditing }}
            onChange={handlePersonalDataChange}
            placeholder="AA123BB"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            disabled={isEditing}
            loading={usuariosLoading}
            options={usuarios}
            getOptionLabel={(option) =>
              option.nombrepila && option.apellido
                ? `${option.nombrepila} ${option.apellido} (${option.username})`
                : option.username || ""
            }
            value={
              usuarios?.find((b) => b.username === datos?.username) || null
            }
            onChange={(event, newValue) => {
              updateFormData("datosPersonales", {
                username: newValue ? newValue.username : null,
              });
            }}
            isOptionEqualToValue={(option, value) =>
              option.username === value.username
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Usuario del Sistema"
                variant="standard"
                InputLabelProps={{ shrink: true }}
                placeholder="Buscar usuario..."
                helperText="Vincular con un usuario de la aplicación"
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
            Teléfonos
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1.5,
              alignItems: "flex-start",
            }}
          >
            {(formData?.telefonosEmpleado || []).map((tel, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  gap: 1,
                  p: 1,
                  border: "1px solid rgba(0,0,0,0.1)",
                  borderRadius: 1,
                  bgcolor: "rgba(0,0,0,0.02)",
                  minWidth: { xs: "100%", sm: "320px" },
                }}
              >
                <FormControl
                  variant="standard"
                  size="small"
                  error={!!errors?.telefonosEmpleado?.[`tipo_${index}`]}
                  sx={{ minWidth: 100 }}
                >
                  <InputLabel>Tipo *</InputLabel>
                  <Select
                    value={tel.tipo}
                    label="Tipo"
                    onChange={(e) => updatePhone(index, "tipo", e.target.value)}
                    disabled={isEditing}
                  >
                    {telefonosTipos.map((tipo, index) => (
                      <MenuItem key={`${tipo.id}-${index}`} value={tipo.id}>
                        {tipo.tipo}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors?.telefonosEmpleado?.[`tipo_${index}`] && (
                    <FormHelperText>
                      {errors.telefonosEmpleado[`tipo_${index}`]}
                    </FormHelperText>
                  )}
                </FormControl>

                <TextField
                  variant="standard"
                  label="Número *"
                  size="small"
                  value={tel.numero}
                  onChange={(e) => updatePhone(index, "numero", e.target.value)}
                  inputProps={{ readOnly: isEditing }}
                  error={!!errors?.telefonosEmpleado?.[`numero_${index}`]}
                  helperText={errors?.telefonosEmpleado?.[`numero_${index}`]}
                  sx={{ flexGrow: 1 }}
                />

                {!isEditing && (
                  <Button
                    color="error"
                    size="small"
                    onClick={() => handleDeleteClick(index, tel)}
                    sx={{ minWidth: "auto", p: 0.5, mb: 0.5 }}
                  >
                    X
                  </Button>
                )}
              </Box>
            ))}

            <Button
              disabled={isEditing}
              variant="outlined"
              size="small"
              onClick={addPhone}
              sx={{ height: 50, px: 2 }}
            >
              + Agregar
            </Button>
          </Box>

          {errors?.telefonosEmpleado &&
            typeof errors.telefonosEmpleado === "string" && (
              <Alert severity="error" sx={{ mt: 1 }}>
                {errors.telefonosEmpleado}
              </Alert>
            )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={2}>
          <TextField
            fullWidth
            variant="standard"
            label="Correo Electrónico"
            name="email"
            type="email"
            value={datos.email || ""}
            inputProps={{ readOnly: isEditing }}
            onChange={handlePersonalDataChange}
            error={!!errors?.email}
            helperText={errors?.email}
            placeholder="ejemplo@empresa.com"
            required
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} lg={2}>
          <TextField
            fullWidth
            variant="standard"
            label="Fecha de Ingreso"
            name="fecha_ingreso"
            type="date"
            value={
              datos.fecha_ingreso
                ? moment(datos.fecha_ingreso).format("YYYY-MM-DD")
                : ""
            }
            inputProps={{ readOnly: isEditing }}
            onChange={handlePersonalDataChange}
            error={!!errors?.fecha_ingreso}
            helperText={errors?.fecha_ingreso}
            InputLabelProps={{ shrink: true }}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} lg={2}>
          <TextField
            fullWidth
            variant="standard"
            label="Fecha de Baja"
            name="fecha_baja"
            type="date"
            value={
              datos.fecha_baja
                ? moment(datos.fecha_baja).format("YYYY-MM-DD")
                : ""
            }
            onChange={handlePersonalDataChange}
            inputProps={{ readOnly: isEditing }}
            error={!!errors?.fecha_baja}
            helperText={errors?.fecha_baja}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Domicilio y Geolocalización
          </Typography>
          <Divider sx={{ mb: 2 }} />
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <FormControl
            fullWidth
            required
            variant="standard"
            inputProps={{ readOnly: isEditing }}
            InputLabelProps={{ shrink: true }}
          >
            <InputLabel id="pais-label">País</InputLabel>
            <Select
              labelId="pais-label"
              id="id_pais"
              name="id_pais"
              inputProps={{ shrink: true }}
              value={datos.id_pais || ""}
              label="Pais"
              disabled={isEditing}
              onChange={handlePersonalDataChange}
            >
              {paises.map((pais, index) => (
                <MenuItem key={`${pais.id_pais}-${index}`} value={pais.id_pais}>
                  {pais.pais}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {datos.xdistancia === 1 && (
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <TextField
              fullWidth
              label="Domicilio residencial actual"
              inputProps={{ readOnly: isEditing, maxLength: 100 }}
              name="domicilio"
              variant="standard"
              value={datos.domicilio || ""}
              onChange={handlePersonalDataChange}
              error={!!errors?.domicilio}
              helperText={errors?.domicilio}
              placeholder="Laprida 1456"
            />
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <FormControl error={!!errors?.xdistancia}>
            <FormControlLabel
              control={
                <Checkbox
                  name="xdistancia"
                  checked={datos.xdistancia === 2}
                  onChange={(e) => {
                    const val = e.target.checked ? 2 : 1;
                    updateFormData("datosPersonales", { xdistancia: val });
                  }}
                  disabled={isEditing}
                />
              }
              label="Fichada Móvil"
              labelPlacement="right"
              sx={{ ml: 1 }}
            />
            {errors?.xdistancia && (
              <FormHelperText sx={{ ml: 4 }}>
                {errors.xdistancia}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        {datos.xdistancia === 2 && (
          <Grid item xs={12} lg={8}>
            <GoogleMapPicker
              address={datos.domicilio}
              lat={datos.latitud}
              lng={datos.longitud}
              onLocationChange={(location) => {
                updateFormData("datosPersonales", {
                  domicilio: location.address,
                  latitud: location.lat,
                  longitud: location.lng,
                });
              }}
            />
          </Grid>
        )}
      </Grid>
      <ConfirmDialog
        open={deleteDialog.open}
        onClose={() =>
          setDeleteDialog({ open: false, index: null, phone: null })
        }
        onConfirm={handleConfirmDeletePhone}
        title="Eliminar teléfono"
        message={
          deleteDialog.phone
            ? `¿Estás seguro de que querés eliminar el teléfono ${deleteDialog.phone.numero} de la lista?`
            : "¿Estás seguro de que querés eliminar este teléfono de la lista?"
        }
        confirmText="Sí, eliminar"
        cancelText="Cancelar"
        variant="danger"
      />
    </>
  );
}
